module.exports = __webpack_public_path__ + "static/postIt03-61774863926fbdab6afd03d6b374f542.svg";